import {ConfigMigrationAnalyticsAction} from 'constants/AnalyticsConstants';

import {
  BaseConfigMigrationEventMetadata,
  CompletedTimedConfigMigrationEventMetadata,
  trackConfigMigrationEvent,
} from './CommonConfigMigrationAnalytics';

// Metadata
export interface CompletedImportPlanObjectMetadata {
  total_migrated_object_count: number;
  migrated_object_count_by_type: Record<string, number>;
}

export type InitiatedImportPlanEventMetadata = BaseConfigMigrationEventMetadata;
export type CompletedImportPlanEventMetadata = CompletedTimedConfigMigrationEventMetadata &
  CompletedImportPlanObjectMetadata;

/**
 * Track when a user initiates import in the new tabs UI.
 * Unlike the legacy per-step import, this imports all objects at once.
 */
export function trackInitiatedImportConfigurationTabs(metadata: InitiatedImportPlanEventMetadata): void {
  trackConfigMigrationEvent(ConfigMigrationAnalyticsAction.INITIATED_IMPORT_CONFIGURATION_TABS, metadata);
}

/**
 * Track when import completes in the new tabs UI.
 * Includes timing information and migrated object counts.
 */
export function trackCompletedImportConfigurationTabs(metadata: CompletedImportPlanEventMetadata): void {
  trackConfigMigrationEvent(ConfigMigrationAnalyticsAction.COMPLETED_IMPORT_CONFIGURATION_TABS, metadata);
}
